import { ApiPageableResponse } from '../types';
import { BaseApiLegalCorporationConfig } from './types';

export const normalizeLegalCorporationConfig = (
  apiResponse: ApiPageableResponse<BaseApiLegalCorporationConfig>,
): BaseApiLegalCorporationConfig | null => {
  return apiResponse?.data ? apiResponse.data[0].attributes : null;
};
